import type { DocumentTab } from 'features/knowledgeDocumentViewer/types'
import { SelectedTab } from 'features/navbar/types'

/**
 * Documents sidebar reuse target: pristine browse-all index only.
 * Tabs with a submitted query (or non-browse-all search) are not index-level.
 */
export function isReusableDocumentsIndexTab(tab: DocumentTab): boolean {
  if (tab.workspaceDestination !== SelectedTab.Documents) return false
  const item = tab.history[tab.currentIndex]
  if (item.type !== 'search') return false
  return (
    item.searchState.browseAll === true &&
    item.searchState.query.trim() === '' &&
    (item.searchState.inputQuery?.trim() ?? '') === ''
  )
}
